<script lang="ts">
	import {
		Dialog,
		DialogOverlay,
		DialogTitle,
		Transition,
		TransitionChild
	} from '@rgossiaux/svelte-headlessui'
    import { onMount, tick } from 'svelte'
	import { Cog, Icon, InformationCircle, X as XIcon } from 'svelte-hero-icons'

    import { browser } from '$app/environment'
    import { goto } from '$app/navigation'
	import { clickOutside } from '$lib/components/ClickOutside/clickOutside.js'
    import IconBell from '$lib/components/Common/Icons/IconBell.svelte'
	import Notification from '$lib/components/Common/Notification/PageNotification.svelte'
    import { messages } from '$lib/messages'
	import { apiGetJson } from '$lib/proxy/apiProxy'
	import { account } from '$lib/stores/account/account'
    import { setAccount } from '$lib/stores/account/manager'
    import { storeBoSettings } from '$lib/stores/bo_settings'
    import { checkLimitReached, getOpenaiTokensLimit } from '$lib/stores/openai/manager'
	import { openai_limit_reached_store } from '$lib/stores/openai/openai'
    import { InitOpenaiThreadItems } from '$lib/stores/openai_thread_items/openai_thread_items'
    import { AccPlanHasFeatureEnabled, Features_Name, InitAccSubPlanFeatures } from '$lib/stores/subscription_acc_plan_features/subscription_acc_plan_features'

    import ToogledTooltip from '../Tooltips/ToogledTooltip.svelte'
	import OpenAI from './Openai.svelte'
						

	export let visible = true

	const len = '10'
	let pathOrigin = '/events/infinite'

	let title = 'AI Assistant'
	let topFilterts = true
	let state = ''
	let events: any[] = []
	let path = '/events/infinite'
	let params: { [name: string]: string } = { state, len }

	let disabled = false

	let messagesEndRef: HTMLDivElement | null = null
	let tokensLimitReached = false

	$: { 
		if ($openai_limit_reached_store) {
			tokensLimitReached = true
			disabled = true
			scrollToBottom()
			messages.info('AI Assistant disabled! Token limit reached.')
		}
	}
	// $: disabled = $openai_limit_reached_store

	const classTabSelected = 'border-blue-600 text-blue-500'
	const classTabUnselected =
		'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 '

	$: classTabAll = state === 'all' ? classTabSelected : classTabUnselected

	$: loadData = visible


	// Watch visible prop to handle Intercom visibility
	$: if (visible) {
		componentOpenAI?.focus()
		toggleIntercom(false) // Hide Intercom when modal opens
	}
	let componentOpenAI: OpenAI

	$: {
		if (loadData) initFilter('all')
		else {
			events = []
			// initialized = false
			state = ''
		}
	}

	$: checkTokensLimit($account.openai_tokens) 

	let tokensLimit = 0

	onMount(async () => {

		await InitAccSubPlanFeatures()
		const featureChecked_enabled = AccPlanHasFeatureEnabled(Features_Name.AI_Expenses)
		disabled = !featureChecked_enabled

		if (!disabled) {
			checkTokensLimit($account.openai_tokens)
			tokensLimit = getOpenaiTokensLimit()
		}
	})

	async function scrollToBottom() {
		await tick()
		messagesEndRef?.scrollIntoView({ behavior: 'smooth' })
	}


	async function checkTokensLimit(accTokens: number) {
		if (browser && !disabled){
			const limit_reached = await checkLimitReached()
			$openai_limit_reached_store = limit_reached
		}
	}
	

	async function getEvents() {
		// GET {{baseUrl}}/events/infinite?len=3
		const jsonData = await apiGetJson(path, params)
		if(!jsonData || jsonData?.error){
			parseNextUrl('')
		} else {
			parseNextUrl(jsonData.next_url)
		}

		events = [...events, ...jsonData.events]
	}

	// Function to toggle Intercom visibility
	function toggleIntercom(show: boolean) {
		//intercom-lightweight-app
		const intercomApp = document.querySelector('.intercom-lightweight-app')
		if (intercomApp) {
			(intercomApp as HTMLElement).style.display = show ? 'block' : 'none'
		}

		const intercomContainer = document.querySelector('#intercom-container')
		if (intercomContainer) {
			(intercomContainer as HTMLElement).style.display = show ? 'block' : 'none'
		}
	}

	// Update the closeDialog function
	const closeDialog = () => {
		visible = false
		toggleIntercom(true) // Show Intercom when modal closes
	}


	const goSettings = () => {
		goto('/settings/application?section=ai-settings')
		closeDialog()
	}

	// const handleSetFilter = async (event: Event, s: string) => {
	// 	event.stopImmediatePropagation()
	// 	event.preventDefault()
	// 	event.stopPropagation()
	// 	initFilter(s)
	// }

	const initFilter = async (s: string) => {
		if (state === s) return // only if change tab

		// initialized = false

		// restore data
		path = pathOrigin
		params = { state: s, len }
		events = []
		// resetInifinite = true

		state = s
		await getEvents()
		// initialized = true
	}

	const parseNextUrl = (next: string) => {
		// there is no data
		if (next === '') {
			path = ''
			params = {}
			return
		}

		// split nextUrl
		let nextSplit = next.split('?')
		let u = nextSplit[1] // get parameters (?...)

		let p: { [name: string]: string } = {}

		// parse querystring
		const urlParams = new URLSearchParams(u)
		urlParams.forEach((v, k) => (p[k] = v)) // convert to object

		params = p
	}

	// const handleLoadMore = async () => {
	// 	if (initialized) await getEvents()
	// }

	// const handleDismissEvent = async (id: string) => {
	// 	console.log('handleDismissEvent')
	// 	try {
	// 		await apiPostJson('/events/state', { id: id, state: 'archived' })
	// 		fetchAccountEventsNews()
	// 		events = events.filter((e) => e.id !== id)
	// 	} catch (err) {
	// 		messages.error("can't archive event")
	// 	}

	// }

	// const handleGoSettings = async () => {
	// 	// console.log('handleGoSettings')
	// 	goSettings()
	// }

	// const handleCloseEvents = async () => {
	// 	// console.log('handleCloseEvents')
	// 	closeDialog()
	// }

	// const handleViewEvent = async (event: any) => {
	// 	if (event.state === 'viewed') return

	// 	try {
	// 		await apiPostJson('/events/state', { id: event.id, state: 'viewed' })
	// 		fetchAccountEventsNews()
	// 		//			events = events.filter( e => e.id !== id )
	// 	} catch (err) {
	// 		messages.error("can't archive event")
	// 	}
	// }

	function handleToggleOffEventList() {
		closeDialog()
	}

	// function handleTokensLimitReached() {
	// 	alert('limit reached')
	// 	console.log('handleTokensLimitReached - limit reached')
	// 	messages.info('AI Assistant disabled! Token limit reached.')	
	// 	tokensLimitReached = true
	// 	disabled = true
	// }
</script>

<Transition show={visible}>
	<Dialog
		open={visible}
		class="fixed inset-0 overflow-hidden z-10"
		aria-labelledby="slide-over-title"
		role="dialog"
		aria-modal="true"
	>
		<TransitionChild
			enter="ease-in-out duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
			leave="ease-in-out duration-500"
			leaveFrom="opacity-100"
			leaveTo="opacity-0"
		>
			<DialogOverlay
				class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
				aria-hidden="true"
			/>
		</TransitionChild>

		<!-- id=globalEventList is used as main-clickoutside in elements that prevent close -->
		<div
			class="fixed inset-y-0 right-0 max-w-full flex"
			id="globalEventList"
			use:clickOutside
			on:click_outside={handleToggleOffEventList}
		>
			<!-- Slide-over panel, show/hide based on slide-over state. -->
			<TransitionChild
				enter="transform transition ease-in-out duration-500 sm:duration-700"
				enterFrom="translate-x-full"
				enterTo="translate-x-0"
				leave="transform transition ease-in-out duration-500 sm:duration-700"
				leaveFrom="translate-x-0"
				leaveTo="translate-x-full"
			>
				<div class="relative w-screen max-w-full sm:max-w-4xl h-full">
					<!-- <div class="h-full flex flex-col bg-white shadow-xl overflow-y-scroll"> -->
					<div class="h-full flex flex-col bg-white">
						<div class="p-6">
							<div class="flex items-start justify-between">
								<DialogTitle
									as="h2"
									class="text-lg font-medium text-gray-900 flex items-center gap-2"
									id="slide-over-title"
								>
									<span>{title}</span>
					
									<ToogledTooltip
										tooltipInfo={"You can ask the AI assistant for information about your invoices, estimates, clients, items, and expenses. It can provide insights and answers but can't take any actions."}
										tooltipBottom={true}
										tooltipDisableHover={false}
										tooltipStyle="--tooltip-width: 280px; --tooltip-left: 100px;"
									>
										<Icon src={InformationCircle} class="text-gray-400 w-5 h-5 md:w-6 md:h-6" />
									</ToogledTooltip>
									<ToogledTooltip
										tooltipInfo='Settings'
										tooltipBottom={true}
										tooltipDisableHover={false}
										tooltipStyle=""
									>
										<button
											class="flex text-gray-400 hover:text-gray-500"
											on:click={goSettings}>
											<Icon src={Cog} class="h-6 w-6" />
										</button>
									</ToogledTooltip>

								</DialogTitle>
								<div class="ml-3 flex h-7 items-center">
									<button
										type="button"
										class="rounded-md text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500"
									>
										<span class="sr-only">Close panel</span>
										<!-- svelte-ignore a11y-click-events-have-key-events -->
										<div on:click={closeDialog}>
											<Icon src={XIcon} class="h-6 w-6" />
										</div>
									</button>
								</div>
							</div>
							<Notification name='notification_openai'/>
						</div>

						{#if topFilterts}
							<div class="border-b border-gray-200">
								{#if $account.openai_data_consent}
									<div class="flex justify-between px-6">
										<nav class="-mb-px flex space-x-6">
											<!-- Current: "border-indigo-500 text-indigo-600", Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
											<!-- <a href={null}
												class="${classTabAll} whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
												>Current Thread</a
											> -->
											<a href={null}
												class="${classTabAll} whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
												on:click={() => {
													setAccount({openai_thread_id: ''})
													InitOpenaiThreadItems('')
												}}
												>New chat</a
											>
											
										</nav>
										{#if $storeBoSettings.admin}
											<div class="total-tokens">Total tokens used: {$account.openai_tokens} / {tokensLimit}</div>
										{/if}
									</div>
		
								{/if}
							</div>
						{/if}
				

						<div class="h-full flex flex-col shadow-xl overflow-y-scroll">
							{#if $account.openai_data_consent}
								<OpenAI 
									bind:this={componentOpenAI}
									disabled={tokensLimitReached} 
								/>
							{:else}
								<ul class="modeless-box-list">
									<li class="flex justify-center align-middle">
										<IconBell />
									</li>
									<li class="text-center">
										<p class="text-xl text-gray-800">To continue, you need to consent to the use of your data for AI processing</p> 
										<div class="flex justify-center text-gray-600 m-4">
											<input id="default-checkbox"
												data-test-id="openai_consent_checkbox"
												type="checkbox" 
												checked={false} 
												class="w-4 h-4  text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500   focus:ring-2 "
												on:change={(e) => {
													if (e.target instanceof HTMLInputElement) {
														e.target.checked = true
														setAccount({openai_data_consent: true})
													}
												}}
												>
											<label for="default-checkbox" class="ms-2 text-sm font-medium text-gray-900  pl-2">
												Yes, I agree to using my data for AI processing.
											</label>
										</div>
										<p class="ms-2 text-sm font-medium text-gray-900 ">
											<a href="https://invoicer.ai/privacy">Privacy Policy</a>
										</p>
									</li>									

								</ul>
							{/if}	

							{#if tokensLimitReached}
								<ul class="modeless-box-list">
									<li class="flex justify-center align-middle">
										<IconBell />
									</li>
									<li class="text-center">
										<!-- <p class="text-xl text-gray-800">Invoicer Assistant disabled!</p> -->
										<p class="text-xl text-gray-800">AI Assistant is either disabled or the token limit has been reached.</p>
									</li>
								</ul>
								<br/>
								<br/>
							{/if}
							<div bind:this={messagesEndRef}></div>

						<div/>
					</div>
				</div>
			</TransitionChild>
		</div>
	</Dialog>
</Transition>


<style lang="postcss">

	.total-tokens {
		padding: 8px;
		text-align: right;
		font-size: 12px;
		color: #666;
	}

</style>
